import { render } from "./SiteLogoImg.vue?vue&type=template&id=c5805442"
import script from "./SiteLogoImg.vue?vue&type=script&lang=js"
export * from "./SiteLogoImg.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__